import { render, staticRenderFns } from "./badge.vue?vue&type=template&id=ae065658&"
import script from "./badge.vue?vue&type=script&lang=js&"
export * from "./badge.vue?vue&type=script&lang=js&"
import style0 from "./badge.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports